module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/sunlight.69dae10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/sunlight.jpg
// module id = GlxQ
// module chunks = 0